import { ITinhTrangNoMonActionTypes } from "../../action-types/tinh-trang-no-mon/ITinhTrangNoMonActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITinhTrangNoMonReducer } from "../../reducer-model/tinh-trang-no-mon/ITinhTrangNoMonReducer";

const iniState: ITinhTrangNoMonReducer = {
    status: eReducerStatusBase.is_not_initialization,
    tinhTrangNoMons: [],
    focusedValueLop: undefined,
    focusedTab: "tat-ca",
    selectedTrangThaiHoc: [0],
    selectedIdSvs: []
}

export const tinhTrangNoMonReducer = (state: ITinhTrangNoMonReducer = iniState, action: ITinhTrangNoMonActionTypes): ITinhTrangNoMonReducer => {
    switch (action.type) {
        case "TINH_TRANG_NO_MON_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "TINH_TRANG_NO_MON_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tinhTrangNoMons: action.payload,
            };
        case "TINH_TRANG_NO_MON_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "TINH_TRANG_NO_MON_CHANGE_FOCUSED_VALUE_LOP":
            return {
                ...state,
                focusedValueLop: action.payload,
            };
        case "TINH_TRANG_NO_MON_CHANGE_FOCUSED_TAB_CHANGE":
            return {
                ...state,
                focusedTab: action.payload,
            };
        case "TINH_TRANG_NO_MON_CHANGE_SELECTED_TRANG_THAI_HOC":
            return {
                ...state,
                selectedTrangThaiHoc: action.payload,
            };
        case "TINH_TRANG_NO_MON_CHANGE_SELECTED_ID_SVS":
            return {
                ...state,
                selectedIdSvs: action.payload,
            };
        default:
            return state;
    }
}